export default __webpack_public_path__ + "static/media/depositWithdrawalIcon6.40ad3b1a.webp";